import React from 'react';
import App, { UserMenus, PassageSlim } from 'codeArt/external/containers/App';
import { Route, Switch, withRouter } from 'react-router-dom';
import asyncComponent from '../util/asyncComponent';
import { MenuRoot, MenuGroup, Menu, MenuItem } from 'codeArt/components/Menu';
import { Events, DomainConfig } from 'js/context';
import { roleCodes, permissionCodes } from 'js/auth';
import { RequestConfig, Notification, Request, Util } from 'codeArt/common';
import Backdrop from 'codeArt/components/Backdrop';
import { Explorer } from 'codeArt/components/Explorer';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import { DEEP_PURPLE } from 'codeArt/external/constants/ThemeColors';
import LanguageIcon from '@material-ui/icons/Language';
import { ExplorerConfig } from 'codeArt/components/Explorer';
import { Principal } from 'codeArt/auth';
import BatteryChargingFullIcon from '@material-ui/icons/BatteryChargingFull';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';
import BatteryCharging20Icon from '@material-ui/icons/BatteryCharging20';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import SettingsInputSvideoIcon from '@material-ui/icons/SettingsInputSvideo';
import OpacityIcon from '@material-ui/icons/Opacity';
import ScannerIcon from '@material-ui/icons/Scanner';
import AlarmOffIcon from '@material-ui/icons/AlarmOff';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import SpeedIcon from '@material-ui/icons/Speed';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import FilterTiltShiftIcon from '@material-ui/icons/FilterTiltShift';
import ShutterSpeedIcon from '@material-ui/icons/ShutterSpeed';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import NetworkCheckOutlinedIcon from '@material-ui/icons/NetworkCheckOutlined';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import importData from './data/index';
import { Comparator } from './components/comparator';
import { IconButton } from '@material-ui/core';
import { WarningContext } from './components/warning';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { RealTime } from './components/device/realTime';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import EventNoteIcon from '@material-ui/icons/EventNote';
import DnsIcon from '@material-ui/icons/Dns';
import StyleIcon from '@material-ui/icons/Style';
import DashboardIcon from '@material-ui/icons/Dashboard';

importData();

export function toSignin(e, time) {
  Notification.error(e);
  setTimeout(() => {
    window.location.replace(`/signin`);
  }, time || 1000)
}

export default class Index extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  login(cb) {
    let my = this;
    Request({
      url: "/enter",
      success: (r) => {
        Principal.setAuth(r);
        cb();
      }, error: (e) => {
        toSignin(e);
      }
    });
  }

  init(cb) {
    RequestConfig.domain = DomainConfig.request.personal;
    RequestConfig.uploadUrl = DomainConfig.file + "/upload.htm";

    ExplorerConfig.set({
      getRoots: "/getPersonalExplorerRoots",
      getDirectory: "/getPersonalDirectory",

      getVirtualDirectory: "/getVirtualDirectory",
      getRootDirectory: "/getRootDirectory",
      getItems: "/getExplorerItems",
      createDirectory: "/createDirectory",
      "delete": "/deleteExplorerItems",
      rename: "/renameExplorerItem",
      moveFiles: "/moveFiles",
    });


    Principal.getItemKey = (key) => {
      return key;
    }

    cb();
    // this.login(cb);
  }

  menus() {
    let { match } = this.props;
    return (
      <MenuRoot>
        <MenuGroup title="开始">
          <MenuItem icon={DashboardIcon} className="menu no-arrow" to={`${match.url}/board/home`}>车间看板</MenuItem>
        </MenuGroup>
        <MenuGroup title="数据">
          <MenuItem icon={ImportantDevicesIcon} className="menu no-arrow" to={`${match.url}/device/all/index`}>设备状态</MenuItem>
          <Menu title="汇总统计" icon={EqualizerIcon}>
            <MenuItem to={`${match.url}/analysis/production/index`}>生产</MenuItem>
            <MenuItem to={`${match.url}/analysis/scrap/index`}>废品</MenuItem>
            <MenuItem to={`${match.url}/analysis/stop/index`}>停机</MenuItem>
            <MenuItem to={`${match.url}/analysis/parameter/index`}>参数</MenuItem>
            <MenuItem to={`${match.url}/analysis/quality/index`}>质量</MenuItem>
            <MenuItem to={`${match.url}/analysis/cost/index`}>消耗品</MenuItem>
          </Menu>
          <Menu title="评价" icon={LocalActivityIcon}>
            <MenuItem to={`${match.url}/report/home`}>报告书</MenuItem>
            <MenuItem to={`${match.url}/ai/home`}>AI智能分析</MenuItem>
          </Menu>
        </MenuGroup>
        <MenuGroup title="业务">
          <Menu title="生产计划" icon={EventNoteIcon}>
            <MenuItem to={`${match.url}/plan/calendar`}>生产日历</MenuItem>
            <MenuItem to={`${match.url}/plan/list`}>计划清单</MenuItem>
          </Menu>
          <Menu title="成品库" icon={DnsIcon}>
            <MenuItem to={`${match.url}/stock/home`}>当前库存</MenuItem>
            <MenuItem to={`${match.url}/stock/list`}>成品清单</MenuItem>
          {/*   <MenuItem to={`${match.url}/stock/report`}>统计分析</MenuItem> */}
          </Menu>
          <Menu title="库存管理" icon={StyleIcon}>
            <MenuItem to={`${match.url}/material/home`}>库存一览</MenuItem>
            <MenuItem to={`${match.url}/material/purchase`}>采购流水</MenuItem>
          </Menu>
        </MenuGroup>
        {/* <MenuGroup title="统计">
          <MenuItem icon={NetworkCheckOutlinedIcon} className="menu no-arrow" to={`${match.url}/analysis/production/index`}>生产</MenuItem>
          <MenuItem icon={DeleteOutlineIcon} className="menu no-arrow" to={`${match.url}/analysis/scrap/index`}>废品</MenuItem>
          <MenuItem icon={BatteryCharging20Icon} className="menu no-arrow" to={`${match.url}/analysis/stop/index`}>停机</MenuItem>
          <MenuItem icon={SettingsInputSvideoIcon} className="menu no-arrow" to={`${match.url}/analysis/parameter/index`}>参数</MenuItem>
          <MenuItem icon={OpacityIcon} className="menu no-arrow" to={`${match.url}/analysis/quality/index`}>质量</MenuItem>
          <MenuItem icon={HourglassEmptyIcon} className="menu no-arrow" to={`${match.url}/analysis/cost/index`}>消耗品</MenuItem>
        </MenuGroup> */}



        {/* <MenuGroup title="评价">
          <MenuItem icon={ShutterSpeedIcon} className="menu no-arrow" to={`${match.url}/report/home`}>报告书</MenuItem>
          <MenuItem icon={LocalActivityIcon} className="menu no-arrow" to={`${match.url}/ai/home`}>AI智能分析</MenuItem>

        </MenuGroup> */}

        {/* <MenuGroup title="评价">
          <MenuItem icon={LocalActivityIcon} className="menu no-arrow" to={`${match.url}/analysis/performance/index`}>设备状态</MenuItem>
          <MenuItem icon={SpeedIcon} className="menu no-arrow" to={`${match.url}/analysis/stop/index`}>性能</MenuItem>
          <MenuItem icon={FitnessCenterIcon} className="menu no-arrow" to={`${match.url}/analysis/scrap/index`}>重量</MenuItem>
        </MenuGroup>

        <MenuGroup title="优化">
          <MenuItem icon={ScatterPlotIcon} className="menu no-arrow" to={`${match.url}/analysis/performance/index`}>Scenes</MenuItem>
          <MenuItem icon={TrackChangesIcon} className="menu no-arrow" to={`${match.url}/analysis/stop/index`}>追踪器界面</MenuItem>
          <MenuItem icon={FilterTiltShiftIcon} className="menu no-arrow" to={`${match.url}/analysis/scrap/index`}>IAS</MenuItem>
        </MenuGroup> */}

      </MenuRoot>
    )
  }

  warning(){
    return (
      <IconButton className="icon-btn text-white quick-menu" onClick={()=>{ WarningContext.current.open(); }}>
        <i className="zmdi zmdi-notifications-none icon-alert animated infinite wobble"/>
      </IconButton>
    );
  }

  render() {
    let { match, history } = this.props;
    return (
      <App name="common" init={this.init.bind(this)} menus={this.menus()} passage={(e) => { this.refs.passage.open(e); }}
      toolbar={[this.warning()]}
      >
        <Switch>
          <Route path={`${match.url}/board`} component={asyncComponent(() => import('./routes/board'))} />
          <Route path={`${match.url}/device`} component={asyncComponent(() => import('./routes/device'))} />
          <Route path={`${match.url}/analysis`} component={asyncComponent(() => import('./routes/analysis'))} />
          <Route path={`${match.url}/report`} component={asyncComponent(() => import('./routes/report'))} />
          <Route path={`${match.url}/ai`} component={asyncComponent(() => import('./routes/ai'))} />
          <Route path={`${match.url}/plan`} component={asyncComponent(() => import('./routes/plan'))} />
          <Route path={`${match.url}/stock`} component={asyncComponent(() => import('./routes/stock'))} />
          <Route path={`${match.url}/material`} component={asyncComponent(() => import('./routes/material'))} />
        </Switch>
        <PassageSlim ref='passage' items={[{ label: "退出", icon: ExitToAppOutlinedIcon, click: () => { Principal.signOut(); history.push("signin"); } }]} />
        <Comparator />
        <WarningContext />
        <RealTime />
      </App>
    )
  }
}
